import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { MessageIcon } from '@instinet-analytics/semantic-ui-components';

export default function failedCellRenderer({ data }: ICellRendererParams) {
    const message = data?.error;
    return (
        <div className="failure-cell">
            <MessageIcon title={message} />
        </div>
    );
}
